export default {"src":"/_next/static/media/OPK.5a521d05.svg","height":18,"width":18};